// extracted by mini-css-extract-plugin
export default {"wrap":"vacationsComments_wrap__XFdcG","message":"vacationsComments_message__TsXQB","hr":"vacationsComments_hr__r---Y","chatText":"vacationsComments_chatText__XCLJc"};